import { useQuery, useQueryClient } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

export type StoreSettings = Record<string, string>;

export function useStoreSettings() {
  return useQuery({
    queryKey: ['store-settings'],
    queryFn: async (): Promise<StoreSettings> => {
      const { data, error } = await supabase.from('store_settings' as any).select('key, value');
      if (error) throw error;
      const out: StoreSettings = {};
      for (const row of (data ?? []) as any[]) out[row.key] = row.value ?? '';
      return out;
    },
    staleTime: 60_000,
  });
}

export function useSaveStoreSettings() {
  const qc = useQueryClient();
  return async (values: StoreSettings) => {
    const rows = Object.entries(values).map(([key, value]) => ({ key, value }));
    const { error } = await supabase.from('store_settings' as any).upsert(rows, { onConflict: 'key' });
    if (error) throw error;
    await qc.invalidateQueries({ queryKey: ['store-settings'] });
  };
}

export function useCurrentAffairsEnabled() {
  const { data } = useStoreSettings();
  return (data?.ca_page_enabled ?? 'true') !== 'false';
}

export function buildUpiLink(opts: { upiId: string; payee: string; amount: number; note: string }) {
  const params = new URLSearchParams({
    pa: opts.upiId,
    pn: opts.payee || 'Indur Study Circle',
    am: String(Math.round(opts.amount)),
    cu: 'INR',
    tn: opts.note.slice(0, 40),
  });
  return `upi://pay?${params.toString()}`;
}